var render = function render(){var _vm=this,_c=_vm._self._c;return _c('popup',{attrs:{"buttonStyle":"success","button-text":_vm.addSuffix ((_vm.totals + 1), false) +' Option',"heading":"New Option","buttonIcon":"fa fa-plus","disableButton":_vm.disableButton},on:{"save":_vm.onSave,"cancel":_vm.onCancel}},[_c('acquire-details',{attrs:{"row-data":_vm.rta,"site-data":_vm.siteData,"adding":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }